<main [class.main--unframed]="!layoutService.isFramed()">
  <div class="content">
    <router-outlet />
  </div>
  @if (!hideNavbar()) {
  <ootd-navbar />
  }
  <p-toast position="top-center" />
  <p-confirmDialog />
  <ootd-season-recap />
</main>